<template>
    <div>
        <EditorBlock title="Flipbook" :optional="true" :block="block">
            <div>
                <b-input-group prepend="Title">
<!--                    <b-input type="text" v-model="block.title" placeholder="Click on a Grade to see a PREVIEW"></b-input>-->
                    <html-editor v-model="block.title" class="ml-3 w-75"></html-editor>
                </b-input-group>
                <b-card v-for="(book, i) in block.books" class="m-2" :title="`Book ${i+1}`" :key="`flipbook_${i}`">
                    <b-input-group prepend="Label" class="my-1">
<!--                        <b-input type="text" v-model="book.label" placeholder="1st Grade"></b-input>-->
                        <html-editor v-model="book.label" class="ml-3 w-75"></html-editor>
                    </b-input-group>
                    <b-input-group prepend="Image" class="my-1"><b-input type="text" v-model="book.image" placeholder="https://cdn.studiesweekly.com/store/pages/science/Kindergarten.png"></b-input></b-input-group>
                    <b-input-group prepend="Url" class="my-1"><b-input type="text" v-model="book.url" @input="getIdFromUrl(book, i)" placeholder="https://online.flippingbook.com/view/12345"></b-input></b-input-group>
                    <b-input-group prepend="Id" class="my-1"><b-input type="text" :value="book.id" disabled></b-input></b-input-group>

                    <b-button variant="danger" @click="deleteBook(i)">Remove Book</b-button>
                </b-card>
                <b-button @click="addBook()" class="m-2 float-right">Add Book</b-button>
            </div>
        </EditorBlock>
    </div>
</template>

<script>
import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";
import HtmlEditor from "@/components/dashboard/storeadmin/HtmlEditor";
export default {
    name: "FlipBook",
    components: {HtmlEditor, EditorBlock},
    props: ['block'],
    data: () => ({
        urls: [],
    }),
    methods: {
        addBook() {
            this.block.books.push({image: null, label: "", id: null});
        },
        deleteBook(i) {
            this.block.books.splice(i, 1);
        },
        getIdFromUrl(book, i) {
            let url = book.url;
            // Captures the end digits on the url
            let regex = /^https:\/\/online.flippingbook.com\/view\/([0-9]+)/;
            let match = url.match(regex);
            if (match && match.length)
                this.block.books[i].id = match[1];
        }
    },
    watch: {

    }

}
</script>

<style scoped>

</style>